<template>
    <div>
        <super-header></super-header>
        <div>
            <div class="">
                <h3
                    class="text-3xl font-bold text-gray-500"
                >
                    Update Contest
                </h3>
            </div>
            <div
                v-if="formData.title"
            >
                <create-contest-form
                    :submit-form="submitForm"
                    :form-data="formData"
                    :update="true"
                ></create-contest-form>
            </div>
        </div>
    </div>
</template>
<script>
import { ENV_URL } from '../../environment.js';
import axios from 'axios';
import SuperHeader from '@/js/components/super/SuperHeader.vue';
import CreateContestForm from '@/js/components/super/CreateContestForm.vue';

export default {
    components: {
        SuperHeader,
        CreateContestForm,
    },
    data () {
        return {
            formData: {},
        };
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        contest () {
            return this.$store.state.contest;
        },
    },

    mounted() {
        const uri = ENV_URL + this.$route.path;
        axios.get(`/api/contests/${this.$route.params.contest}`)
            .then((res) => {
                this.formData = res.data;
            })
    },

    methods: {
        submitForm(data) {
            this.$store.dispatch('LOADING', true);
            let authHeaders = {
                headers: {"Authorization": `Bearer ${this.$store.state.laravelAuthToken}`}
            };
            // /super/contests/{contest}/entries/{id}/update
            let uri = ENV_URL + `/super/contests/${this.$route.params.contest}/update`;
            axios.post(uri, data, authHeaders)
                .then((response) => {
                }).finally(() => {
                this.$store.dispatch('LOADING', false);
            });
        },
    },
}
</script>

<style lang="scss">

</style>
